"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "LabLogo___StyledSvg",
  componentId: "otjxnb-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

function LabLogo(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M263.068 88.26c15.815 0 28.305-12.902 28.305-28.717 0-15.816-12.49-28.719-28.305-28.719-15.816 0-28.306 12.903-28.306 28.719 0 15.815 12.902 28.718 28.306 28.718zm7.076 34.133c-8.74 0-15.816 7.076-15.816 15.816 0 8.739 7.077 15.815 15.816 15.815 8.74 0 15.816-7.076 15.816-15.815 0-8.327-7.077-15.816-15.816-15.816zm99.483 265.169l-82.843-128.627v-30.807c4.164-1.663 9.99-4.576 14.565-9.151 10.828-10.828 9.152-33.308 8.327-42.872-.838-6.238-5.826-9.99-12.078-9.99H181.035c-6.238 0-11.24 3.752-11.652 9.99-1.25 9.578-3.325 32.47 7.489 43.298 5.001 5.001 9.99 7.488 14.153 8.739v30.806L109.02 387.576c-2.075 3.325-2.075 7.488-.412 11.24.838 2.074 24.142 50.373 120.3 50.373h20.391c96.57 0 119.05-47.873 120.3-50.373 2.076-3.326 2.076-7.49 0-11.24l.028-.014zm-170.262-59.113v.838l-49.123 78.254c-8.327-5.002-13.315-9.99-16.228-13.74l80.343-125.303c1.25-2.075 1.662-4.163 1.662-6.664v-43.71c0-6.664-4.575-11.652-10.827-12.077 0 0-6.239-.839-9.99-5.002-1.663-1.663-2.5-5.826-2.5-14.153h94.082c-.412 8.327-.838 12.49-2.075 13.74-4.163 4.164-11.24 5.002-11.24 5.002-6.664.413-12.078 5.826-12.078 12.078v44.122c0 2.5 1.25 4.163 2.501 6.238l39.546 60.363H199.365v.014zm7.503-187.314c13.74 0 24.98-11.24 24.98-25.393s-11.24-25.393-24.98-25.393c-13.741 0-24.98 11.24-24.98 25.393s11.239 25.393 24.98 25.393z"
  }));
}

var _default = LabLogo;
exports["default"] = _default;